import type { CSSProperties, SelectHTMLAttributes } from 'react';

export interface BBOldSelectProps
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label: string;
  options: Array<string>;
  value: string;
  onChange: (evt: React.ChangeEvent<HTMLSelectElement>) => void;
  sx?: CSSProperties;
}

const SELECT: CSSProperties = {
  padding: '10px 14px',
  fontSize: '14px',
  borderRadius: '4px',
  border: '1px solid var(--chakra-colors-border)',
  background: 'var(--chakra-colors-bg)',
  color: 'var(--chakra-colors-fg)',
  cursor: 'pointer',
  minWidth: 200,
};

export const BBOldSelect = ({ label, options, value, onChange, sx, ...rest }: BBOldSelectProps) => {
  const displayed = value ? `${label.split(' ').pop()}: ${value}` : `Select: ${label}`;

  return (
    <select
      {...rest}
      value={value}
      onChange={onChange}
      aria-label={label}
      style={{ ...SELECT, ...sx }}
    >
      <option value="" disabled>
        {displayed}
      </option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};
